import React from 'react';
import styled from 'styled-components';
import {colours} from '../Styles';
import {additionalServices} from '../PackageDetails';

function AdditionalServicesCard() {
    const {light, accent} = colours;
    const AdditionalServicesCard = styled.div`
        width: 500px;
        height: max-content;
        background: white;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        .service-list {
            list-style: none;
            width: 95%;
            margin-top: 10px;
            margin-bottom: 10px;
            li {
                padding: 5px 10px;
                display: flex;
                :nth-child(2n) {
                background: ${light}
                }
                .price {
                    color: ${accent};
                    font-weight: bold;
                    width: 15%;
                }
            }
        }
        .extra-bar {
            height: 30px;
            width: 100%;
            background: ${accent};
            font-family: montserrat, sans-serif;
            font-size: 12px;
            color: ${light};
            display: flex;
            align-items: center;
            justify-content: center;
        }
        @media only screen and (max-width: 600px) {
            width: 90%;
        }
    `;
const servicesList = additionalServices.map((item) => <li><div className="price">${item.price}</div>{item.name}</li>)
    return (
        <AdditionalServicesCard>
            <ul className="service-list">
                {servicesList}
            </ul>
            <div className="extra-bar">Pricing may vary for larger vehicles</div>
        </AdditionalServicesCard>
    )
}

export default AdditionalServicesCard;